import { render, staticRenderFns } from "./hotel-input.vue?vue&type=template&id=2216adce&"
import script from "./hotel-input.vue?vue&type=script&lang=js&"
export * from "./hotel-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports